import React, { CSSProperties, ReactNode } from 'react';
import { useAppSelector } from 'hooks';
import classNames from 'classnames';
import { Dayjs } from 'dayjs';

import { dateInputFieldFormat } from '~libs/dayjs';
import { Appointment, Client, Event, Worker } from '~weekly-planner/lib/common';

import Spinner from '~components/Spinner';

import { selectRowLoading } from '~weekly-planner/selectors/users';
import { selectWorkerLeaveStatus } from '~weekly-planner/selectors/users/leaveStatus';

import Cell from './Cell';

interface ComponentProps {
  headerCell: ReactNode;
  data: Worker | Client;
  date: Dayjs;
  events: Event[];
  getAppointmentTitle: (appointment: Appointment) => string;
  style?: CSSProperties;
}

const Row: React.FC<ComponentProps> = ({ headerCell, data, date, events, style, getAppointmentTitle }) => {
  const { id } = data;
  const isOnLeave = useAppSelector((state) => selectWorkerLeaveStatus(state, data.id, date));

  const className = classNames('worker-row', {});
  const parsedId = parseInt(data.id);
  const loading = useAppSelector((state) => selectRowLoading(state, isNaN(parsedId) ? 0 : parsedId));
  const isLoading = loading === 'pending';
  return (
    <div id={id} className={className} key={`${id}`} data-date={date.format(dateInputFieldFormat)}>
      {headerCell}
      <Cell
        data={data}
        date={date}
        events={events}
        style={style}
        startDate={date.weekday(0)}
        getAppointmentTitle={getAppointmentTitle}
        isOnLeave={isOnLeave}
      />
      {isLoading && (
        <div className="row-spinner-overlay" style={{ ...style }}>
          <Spinner loading={isLoading} />
        </div>
      )}
    </div>
  );
};

export default Row;
